export const publish = async <T>(topic: string, payload?: T): Promise<void> => {
  const publishUrl = `/xhr/mercure/${topic}/publish`;
  const options = { method: 'POST' } as RequestInit;
  if (payload) {
    options.body = JSON.stringify(payload);
  }
  await fetch(publishUrl, options);
};

export const getSubscribeToken = async (topic: string): Promise<string | null> => {
  const authorizeUrl = `/xhr/mercure/${topic}/authorize`;
  const response = await fetch(authorizeUrl);
  const { token } = await response.json();
  return token;
};
